/* eslint-disable react/prop-types */
const Title = ({ text1, text2 }) => {
  return (
    <div className=" heading-1  text-center pt-8">
      <div className="inline-flex gap-2 items-center mb-3">
        <p className="text-prime-red playfair-display">
          {text1}{" "}
          <span className="text-prime-red font-medium playfair-display">
            {text2}
          </span>
        </p>
        <p className="w-8 sm:w-12 h-[2px] bg-zinc-500"></p>
      </div>
    </div>
  );
};

export default Title;
